<template>
    <div>
      <div style="text-align: left;margin-bottom: 15px">
        <el-input style="width: 360px" placeholder="输入关键字搜索牛人" v-model="searchKeyWord" class="input-with-select" @keyup.enter.native="searchTalentsClickHandle">
          <el-button slot="append" icon="el-icon-search" @click="searchTalentsClickHandle"></el-button>
        </el-input>
      </div>

      <el-table
        ref="multipleTable"
        width="100%"
        border
        maxHeight="800"
        :data="tableData"
        tooltip-effect="dark">
        <el-table-column
          fixed="left"
          prop="userName"
          :show-overflow-tooltip="true"
          label="姓名"
          width="130">
          <template slot-scope="scope">
            <span class="user-name" @click="showResume(scope.row)">{{scope.row.userName ? scope.row.userName : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="positionName"
          label="所投职位"
          width="160"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          label="工作年限"
          width="100"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.workingLife ? scope.row.workingLife / 10 + '年' : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="学历"
          width="60"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.educationDict ? scope.row.educationDict.dictName : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="jobStatus"
          label="求职状态"
          width="120"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.jobStatus ? scope.row.jobStatus : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          width="110"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.phone ? scope.row.phone : '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="introduce"
          label="个人简介"
          width="500"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.introduce ? scope.row.introduce : '--'}}</span>
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          fixed="right"-->
<!--          prop="isChecked"-->
<!--          label="状态"-->
<!--          width="80"-->
<!--          :show-overflow-tooltip="true">-->
<!--          <template slot-scope="scope">-->
<!--            <span :style="stateColor(showStatus(scope.row))">{{showStatus(scope.row)}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          fixed="right"-->
<!--          label="操作"-->
<!--          width="100">-->
<!--          <template slot-scope="scope">-->
<!--            <span class="op-icon op-view" :class="statusDisabled(scope.row, 'isChecked') ? 'op-disabled' : ''" :title="showStatusTitle(scope.row, 'mark')" @click="markCheckedStatus(scope.row, 'isChecked', 2)"><i class="el-icon-view"></i></span>-->
<!--            <span class="op-icon op-refuse" :class="statusDisabled(scope.row, 'isAccept') ? 'op-disabled' : ''" :title="showStatusTitle(scope.row, 'refuse')" @click="markCheckedStatus(scope.row, 'isAccept', 1)"><i class="el-icon-close"></i></span>-->
<!--            <span class="op-icon op-receive" :class="statusDisabled(scope.row, 'isAccept') ? 'op-disabled' : ''" :title="showStatusTitle(scope.row, 'accept')" @click="markCheckedStatus(scope.row, 'isAccept', 2)"><i class="el-icon-check"></i></span>-->
<!--            <span class="op-icon op-download" title="下载简历" @click="downloadResume(scope.row)"><i class="el-icon-bottom"></i></span>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>

      <user-resume v-if="showUserResumeFlag" :showUserResumeFlag="showUserResumeFlag" :userResume="showUserResumeObj" @hideUserResume="hideUserResume()"></user-resume>
    </div>
</template>

<script>
import UserResume from './UserResume'
export default {
  name: 'SearchTalents',
  components: {UserResume},
  data () {
    return {
      searchKeyWord: '',
      tableData: [],
      showUserResumeFlag: false,
      showUserResumeObj: null
    }
  },
  methods: {
    showResume (row) {
      this.showUserResumeFlag = true
      this.showUserResumeObj = row
    },
    hideUserResume () {
      this.showUserResumeFlag = false
      this.showUserResumeObj = null
    },
    searchTalentsClickHandle () {
      console.log(1)
    }
  },
  mounted () {
    for (let i = 0; i < 20; i++) {
      this.tableData.push({
        userName: `姓名_${i}`,
        positionName: `所投职位_${i}`,
        workingLife: `工作年限_${i}`,
        educationDict: {dictName: `学历_${i}`},
        jobStatus: `求职状态_${i}`,
        phone: `电话_${i}`,
        introduce: `个人简介_${i}`
      })
    }
  }
}
</script>

<style scoped>
  .input-with-select /deep/ .el-input-group__append {
    border-color: #409EFF;
  }
  .input-with-select button {
    background: #409EFF;
    color: #fff;
    border-radius: 0;
    cursor: pointer;
  }
  .user-name:hover {
    color: #409eff;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Recruit/SearchTalents.vue